module.exports = __webpack_public_path__ + "images/jd-logo-green@1x9ff4b8d9a0d925bca7202c114ecaffa9.png";